import { UserModule } from '@/store/modules/user';
import { Type } from '@/types/permissionType';
import { checkPermissionCompany, checkPermissionRole, checkPermissionUseAndCompany ,checkPermissionCompanyFromOrderType} from '@/utils/permission';

const TypeTrue = 'TypeTrue';
// 数组是或的关系  每个元素 Permissions 并关系
export const permissions = {
  index: [
    {
      Permissions: Type.REPORT_COMPANY_LOOK,
      type: 1, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole 4checkPermissionCompanyFromOrderType
      vipLev: 1
    },
    {
    // 服务方首页
      Permissions: Type.ORDER_LOOK_COM,
      type: 1, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole  4checkPermissionCompanyFromOrderType
    },
    {
      // 服务方数据看板
      Permissions: Type.ORDER_LOOK_COM,
      type: 3 // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole  4checkPermissionCompanyFromOrderType
    },
    {
      // 报修方订单数据看板
      Permissions: Type.REPORT_ORDER_LOOK,
      type: 3, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole  4checkPermissionCompanyFromOrderType
      vipLev: 1
    },
    // 服务方首页
    {
      Permissions: Type.ORDER_LOOK_COM,
      type: 3 // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole  4checkPermissionCompanyFromOrderType
    },
    {
      Permissions: Type.HOME_MAP,
      type: 3
    },
    {
      Permissions: Type.TASK_LOOK,
      type: 3
    },
    {
      Permissions: Type.TASK_DEAL,
      type: 3
    },
  ],
  indexWorkBench: [
    {
      Permissions: Type.REPORT_COMPANY_LOOK,
      type: 1, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
      vipLev: 1
    },
    {
    // 服务方首页
      Permissions: Type.ORDER_LOOK_COM,
      type: 1 // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
    }],
  dashBoard: [
    {
    // 服务方数据看板
      Permissions: Type.ORDER_LOOK_COM,
      type: 3 // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
    },
    {
    // 报修方订单数据看板
      Permissions: Type.REPORT_ORDER_LOOK,
      type: 3, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
      vipLev: 1
    },
    {
      // 报修方订单数据看板
      Permissions: Type.REPORT_COMPANY_LOOK,
      type: 3, // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
      vipLev: 1
    },
  ],
  indexS: [
    {
      // 服务方首页
      Permissions: Type.ORDER_LOOK_COM,
      type: 3 // 1 checkPermissionUseAndCompany 2 checkPermissionCompany 3 checkPermissionRole
    },
    {
      Permissions: Type.HOME_MAP,
      type: 3
    },
    {
      Permissions: Type.TASK_LOOK,
      type: 3
    },
    {
      Permissions: Type.TASK_DEAL,
      type: 3
    },
  ],
  // 订单管理
  MyOrderAll: [
    { Permissions: Type.MyOrder,
      type: 2
    },
    { Permissions: Type.REPORT_ORDER_LOOK,
      type: 1
    },
    { Permissions: Type.OrederCheck,
      type: 1
    } ],
  // 我的订单
  MyOrder: [
    { Permissions: Type.MyOrder,
      type: 2
    }],
  MyOrderAddOrder: [
    { Permissions: Type.REPORT_CREAT,
      type: 2
    }
  ],
  MyOrderCheckOrder: [
    { Permissions: Type.MyOrderCheckOrder,
      type: 2
    }
  ],
  MyOrderOrder: [
    { Permissions: Type.REPORT_LOOK,
      type: 2
    }
  ],
  // 所有报修
  ReportOrder: [
    { Permissions: Type.REPORT_ORDER_LOOK,
      type: 1
    }],
  ReportOrderAllOrder: [
    { Permissions: Type.REPORT_COMPANY_LOOK,
      type: 1
    },
    { Permissions: Type.REPORT_DEPT_LOOK,
      type: 1
    }],
  ReportOrderCheckOrder: [
    { Permissions: Type.MyOrderCheckOrder,
      type: 2
    }],

  // 审核工单
  CheckManiger: [
    { Permissions: Type.OrederCheck,
      type: 1
    }],
  CheckManigerList: [
    { Permissions: Type.ORDER_CHECK,
      type: 1
    }],
  CheckManigerSetting: [
    { Permissions: Type.CheckManigerSetting,
      type: 1
    }
  ],
  // 订单管理
  ServerOrderAll: [
    { Permissions: Type.SERVICER_MODULE,
      type: 1
    },
    {
      Permissions: Type.ComplaintOrder,
      type: 1
    }
  ],
  // 订单列表
  ServerOrder: [
    { Permissions: Type.SERVICER_MODULE,
      type: 1
    }],
  ServicerOrderAdd: [
    { Permissions: Type.ORDER_ADD,
      type: 1
    }],
  MyAddOrders: [
    { Permissions: Type.MyAddOrders,
      type: 1
    }],
  ServerOrderAllOrder: [
    { Permissions: Type.ORDER_LOOK_COM,
      type: 1
    },
    { Permissions: Type.ORDER_LOOK_DEP,
      type: 1
    }],
  OrderServicerGrabOrder: [
    { Permissions: Type.ORDER_ROB_LOOK,
      type: 1
    }],
  ServerOrderEnquiry: [
    { Permissions: Type.OrderEnquiry,
      type: 4,
      orderType:2,
    }],
  ServerOrder151010: [
    { Permissions: Type.ORDER_LOOK_COM,
      type: 1
    }],
  ServerOrderTurnOrder: [
    { Permissions: Type.ORDER_TRANSFER,
      type: 1
    }],
  ServerOrderOutSource: [
    { Permissions: Type.ServerOrderOutSource,
      type: 1
    }],
  // 任务管理
  OrderTask: [
    {
      Permissions: Type.OrderTask,
      type: 1
    }
  ],
  OrderTaskList: [
    {
      Permissions: Type.TASK_LOOK,
      type: 1
    }
  ],
  // 投诉工单
  ComplaintOrder: [
    {
      Permissions: Type.ComplaintOrder,
      type: 1
    }
  ],
  // 巡检
  PollingOrder: [
    {
      Permissions: Type.EORDER_POLLING,
      type: 1
    }
  ],
  PollingOrderAddOnce: [
    {
      Permissions: Type.PollingOrderAddOnce,
      type: 1
    }
  ],
  PollingOrderList: [
    {
      Permissions: Type.PollingOrderList,
      type: 1
    }
  ],
  PollingOrderCheck: [
    {
      Permissions: Type.PollingOrderCheck,
      type: 1
    }
  ],
  PollingOrderEven: [
    {
      Permissions: Type.PollingOrderEven,
      type: 1
    }
  ],
  PollingOrderSeting: [{
    Permissions: Type.PollingOrderSeting,
    type: 1
  }],
  // 安装
  OrderInstall: [{
    Permissions: Type.InstallModule,
    type: 1
  }],
  OrderInstallAdd: [{
    Permissions: Type.InstallAdd,
    type: 1
  }],
  OrderInstallSource: [{
    Permissions: Type.InstallSource,
    type: 1
  }],
  OrderInstallSetting: [{
    Permissions: Type.InstallSetting,
    type: 1
  }],
  OrderInstallAplay: [{
    Permissions: Type.OrderInstallAplay,
    type: 2
  }],
  OrderInstallAplayAdd: [{
    Permissions: Type.OrderInstallAplayAdd,
    type: 2
  }],
  // 自动推单
  GroupPush: [{
    Permissions: Type.GroupPush,
    type: 1
  }],
  GroupPushCustomer: [{
    Permissions: Type.GroupPushCustomer,
    type: 1
  }],
  GroupPushAddress: [{
    Permissions: Type.GroupPushAddress,
    type: 1
  }],
  GroupPushFault: [{
    Permissions: Type.GroupPushFault,
    type: 1
  }],
  GroupPushTags: [{
    Permissions: Type.GroupPushTags,
    type: 1
  }],
  GroupPushCombine: [{
    Permissions: Type.GroupPushCombine,
    type: 1
  }],
  GroupPushCustomerDept: [{
    Permissions: Type.GroupPushCustomerDept,
    type: 1
  }],
  // 点检
  CyclCheck: [{
    Permissions: Type.CHECKPOINT,
    type: 1
  }],
  // 项目
  Project: [{
    Permissions: Type.Project,
    type: 1
  }],
  ProjectSeting: [
    {
      Permissions: Type.ProjectSeting,
      type: 3
    }
  ],
  ProjectCreate: [
    {
      Permissions: Type.ProjectCreate,
      type: 3
    }
  ],
  ProjectAll: [
    {
      Permissions: Type.ProjectAll,
      type: 3
    }
  ],
  ProjectMy: [
    {
      Permissions: Type.ProjectMy,
      type: 3
    }
  ],
  projectRecycle: [
    {
      Permissions: Type.ProjectRecycle,
      type: 3
    }
  ],
  // 客户管理
  CustomerAll: [
    {
      Permissions: Type.CUSTOMER_COMPANY,
      type: 1
    },
    {
      Permissions: Type.RelatedModule,
      type: 1
    }
  ],
  // 客户管理
  Customer: [
    {
      Permissions: Type.CUSTOMER_COMPANY,
      type: 1
    }
  ],
  CustomerAliasGroup: [
    {
      Permissions: Type.CustomerAliasGroup,
      type: 1
    }
  ],
  // 客户关联
  CustomerRelation: [
    {
      Permissions: Type.RelatedModule,
      type: 1
    }
  ],
  CustomerRelationRelation: [
    {
      Permissions: Type.CustomerRelationRelation,
      type: 1
    }
  ],
  CustomerRelationRelationOrder: [
    {
      Permissions: Type.CustomerRelationRelationOrder,
      type: 1
    }
  ],

  // 公司管理
  Company: [
    { Permissions: Type.Staff,
      type: 1
    },
    { Permissions: Type.PunchTheClock,
      type: 1
    },
    { Permissions: Type.SERVICE_COMPANY,
      type: 1
    },
    { Permissions: Type.BranchCompany,
      type: 1
    },
    { Permissions: Type.CompanyNotice,
      type: 1
    },
    { Permissions: Type.KPI,
      type: 1
    }
  ],
  // 人员管理
  staff: [
    { Permissions: Type.Staff,
      type: 1
    }
  ],
  staffAll: [
    { Permissions: Type.StaffALL,
      type: 1
    }
  ],
  staffRole: [
    { Permissions: Type.StaffRole,
      type: 1
    }
  ],
  staffDepatment: [
    { Permissions: Type.StaffDepatment,
      type: 1
    }
  ],
  staffAutoAssign: [
    { Permissions: Type.StaffAutoAssign,
      type: 1
    }
  ],
  staffScheduling: [
    { Permissions: Type.StaffScheduling,
      type: 1
    }
  ],
  // 考勤签到
  PunchTheClock: [
    { Permissions: Type.PunchTheClock,
      type: 1
    }
  ],
  PunchTheClockRecord: [
    { Permissions: Type.PunchTheClockRecord,
      type: 1
    }
  ],
  PunchTheClockSetting: [
    { Permissions: Type.PunchTheClockSetting,
      type: 1
    }
  ],

  //kpi
  Kpi: [
    { Permissions: Type.KPI,
      type: 1
    }
  ],
  KpiSetting: [
    { Permissions: Type.KPI,
      type: 1
    }
  ],
  // 服务方管理
  Server: [
    { Permissions: Type.SERVICE_COMPANY,
      type: 1
    }
  ],
  // 分公司管理
  Bruanch: [
    { Permissions: Type.BranchCompany,
      type: 1
    }
  ],
  BruanchCompanyList: [
    { Permissions: Type.BranchCompany,
      type: 1
    }
  ],
  BruanchOrderCusGroup: [
    { Permissions: Type.BruanchOrderCusGroup,
      type: 1
    }
  ],
  BruanchOrderCusOrder: [
    { Permissions: Type.BruanchOrderCusOrder,
      type: 1
    }
  ],
  BruanchOrderSerOrder: [
    { Permissions: Type.BRANCH_ORDER_SERVER,
      type: 1
    }
  ],
  BranchOrderServicer: [
    { Permissions: Type.BranchOrderServicer,
      type: 1
    }
  ],
  BruanchOrderDayCheck: [
    { Permissions: Type.BruanchOrderDayCheck,
      type: 1
    }
  ],
  // 公司公告
  CompanyNotice: [
    // { Permissions: Type.CompanyNotice,
    //   type: 1
    // }
    { Permissions: Type.CompanyNoticeInner,
      type: 1
    },
    { Permissions: Type.CompanyCustomerNotice,
      type: 1
    }
  ],
  CompanyNoticeInner: [
    { Permissions: Type.CompanyNoticeInner,
      type: 1
    }
  ],
  CompanyCustomerNotice: [
    { Permissions: Type.CompanyCustomerNotice,
      type: 1
    }
  ],
  // 备件管理
  Part: [
    {
      Permissions: Type.parts,
      type: 1
    }
  ],
  // 库存管理
  Stock: [
    {
      Permissions: Type.Stock,
      type: 1
    }
  ],
  StockTz: [
    {
      Permissions: Type.StockTz,
      type: 1
    }
  ],
  StockApplyInoutRecord: [
    {
      Permissions: Type.StockApplyInoutRecord,
      type: 1
    }
  ],
  StockInOutRecord: [
    {
      Permissions: Type.StockInOutRecord,
      type: 1
    }
  ],
  StockCheck: [
    {
      Permissions: Type.StockCheck,
      type: 1
    }
  ],
  Stocksetting: [
    {
      Permissions: Type.Stocksetting,
      type: 1
    }
  ],
  // 设备管理
  Device: [
    {
      Permissions: Type.Device,
      type: 1
    }
  ],
  Device1: [
    {
      Permissions: Type.ORDER_ADD_BRAND,
      type: 1
    },
    {
      Permissions: Type.device,
      type: 1
    }
  ],
  ProductBrand: [
    {
      Permissions: Type.ORDER_ADD_BRAND,
      type: 1
    }
  ],
  ProductDevice: [
    {
      Permissions: Type.device,
      type: 1
    }
  ],

  ProductAuth: [
    {
      Permissions: Type.ProductAuth,
      type: 1
    }
  ],

  ProductAuthSer: [
    {
      Permissions: Type.ProductAuthSer,
      type: 1
    }
  ],
  // 知识库
  KnowledgeBase: [
    {
      Permissions: Type.Knowledge,
      type: 1
    }
  ],
  KnowledgeSetting: [
    {
      Permissions: Type.KnowledgeSetting,
      type: 1
    }
  ],
  KnowledgeLook: [
    {
      Permissions: Type.KnowledgeLook,
      type: 1
    }
  ],

  // 模版设置
  Template: [{
    Permissions: Type.Template,
    type: 1
  }],
  TemplateDiyField: [{
    Permissions: Type.TemplateDiyField,
    type: 1
  }],
  TemplateRepair: [{
    Permissions: Type.TemplateRepair,
    type: 1
  }],
  TemplateOrder: [{
    Permissions: Type.TemplateOrder,
    type: 1
  }],
  TemplateCustomAddress: [{
    Permissions: Type.myselfPCALs,
    type: 1
  }],
  TemplateFault: [{
    Permissions: Type.fault,
    type: 1
  }],
  TemplateFaultPhenomenon: [{
    Permissions: Type.FAULT_PHENOMENON,
    type: 1
  }],
  TemplatePrice: [{
    Permissions: Type.price,
    type: 1
  }],
  TemplateWorkTime: [{
    Permissions: Type.TemplateWorkTime,
    type: 1
  }],
  TemplateTroubleDescribleTags: [{
    Permissions: Type.TemplateTroubleDescribleTags,
    type: 1
  }],

  TemplateTag: [{
    Permissions: Type.tag,
    type: 1
  }],
  TemplateImageTags: [{
    Permissions: Type.TemplateImageTags,
    type: 1
  }],
  TemplateRemarkTags: [{
    Permissions: Type.TemplateRemarkTags,
    type: 1
  }],
  TemplateEvaluateTags: [{
    Permissions: Type.TemplateEvaluateTags,
    type: 1
  }],
  TemplateEvaluateCustomer: [{
    Permissions: Type.TemplateEvaluateCustomer,
    type: 1
  }],
  TemplateAddedProgressTags: [
    {
      Permissions: Type.TemplateAddedProgressTags,
      type: 1
    }
  ],
  TemplateAplayReason: [{
    Permissions: Type.TemplateAplayReason,
    type: 1
  }],
  TemplateQuestionBank: [{
    Permissions: Type.TemplateQuestionBank,
    type: 1
  }],
  // 统计报表
  Statistics: [{
    Permissions: Type.STATISTICS,
    type: 1
  }],
  StatisticsPerson: [{
    Permissions: Type.StatisticsPerson,
    type: 1
  }],
  StatisticsDeptCusOrder: [{
    Permissions: Type.StatisticsDeptCusOrder,
    type: 1
  }],
  StatisticsDeptSerOrder: [{
    Permissions: Type.StatisticsDeptSerOrder,
    type: 1
  }],
  StatisticsDeptSerOrderWorkTime: [{
    Permissions: Type.StatisticsDeptSerOrderWorkTime,
    type: 1
  }],
  StatisticsDeptCusPrice: [{
    Permissions: Type.StatisticsDeptCusPrice,
    type: 1
  }],
  StatisticsDeptSerPrice: [{
    Permissions: Type.StatisticsDeptSerPrice,
    type: 1
  }],
  StatisticsCusOrder: [{
    Permissions: Type.StatisticsCusOrder,
    type: 1
  }],
  StatisticsCusPrice: [{
    Permissions: Type.StatisticsCusPrice,
    type: 1
  }],
  StatisticsParts: [{
    Permissions: Type.StatisticsParts,
    type: 1
  }],
  StatisticsDevice: [{
    Permissions: Type.StatisticsDevice,
    type: 1
  }],
  StatisticsFaultPhenomenon: [{
    Permissions: Type.StatisticsFaultPhenomenon,
    type: 1
  }],
  StatisticsFalultType: [{
    Permissions: Type.StatisticsFaultType,
    type: 1
  }],
  StatisticsAddress: [{
    Permissions: Type.StatisticsAddress,
    type: 1
  }],
  StatisticsServer: [{
    Permissions: Type.StatisticsServer,
    type: 1
  }],
  StatisticsDiyOrder: [
    {
      Permissions: Type.StatisticsCusDiyOrder,
      type: 1
    },
    {
      Permissions: Type.StatisticsDiyOrder,
      type: 1
    }],
  StatisticsSerDeptDiyOrder: [
    {
      Permissions: Type.StatisticsSerDeptDiyOrder,
      type: 1
    }],
  StatisticsBigData: [
    {
      Permissions: Type.StatisticsBigData,
      type: 1
    },
  ],
  //结算
  Settlement: [
    {
      Permissions: Type.Settlement,
      type: 1
    },
  ],
  SettlementDeal: [
    {
      Permissions: Type.SettlementDeal,
      type: 1
    },
  ],
  // 系统设置
  System: [ {
    Permissions: Type.System,
    type: 1
  }, {
    Permissions: Type.Template,
    type: 1
  }, {
    Permissions: Type.TaskTrack,
    type: 1
  }],
  SystemCompany: [ {
    Permissions: Type.SystemCompany,
    type: 1
  }],
  SystemModule: [ {
    Permissions: Type.SystemModule,
    type: 1
  }],
  SystemOrderSetting: [ {
    Permissions: Type.SystemOrderSetting,
    type: 1
  }],
  ServerIndex: [{
    Permissions: Type.ServerIndex,
    type: 1
  }],
  TrackPathSeting: [ {
    Permissions: Type.TaskTrack,
    type: 1
  }],
  SystemOperationLog: [ {
    Permissions: Type.SystemOperationLog,
    type: 1
  }],

};
export function VShow(data:any) {
  let pList:any = [];
  if (data && data.Permissions) {
    for (let index = 0; index < data.Permissions.length; index++) {
      const element = data.Permissions[index];
      let p = false;
      let arr:any = String(element.Permissions).split(',');
      if (arr && arr.length > 1) {
        let ppps = arr.filter((a:any) => {
          let re = false;
          switch (element.type) {
            case 1:
              re = checkPermissionUseAndCompany(UserModule.getCompanyId, parseInt(a));
              break;
            case 2:
              re = checkPermissionCompany(UserModule.getCompanyId, parseInt(a));
              break;
            case 3:
              re = checkPermissionRole(UserModule.getCompanyId, parseInt(a));
              break;
            case 4: 
              re = checkPermissionCompanyFromOrderType(UserModule.getCompanyId, parseInt(a), element.orderType);
              break;
          }

          return re;
        });
        p = ppps && (ppps.length === arr.length);
        pList.push(p);
      } else if (arr.length === 1) {
        if (arr[0] === TypeTrue) {
          p = true;
        } else {
          switch (element.type) {
            case 1:
              p = checkPermissionUseAndCompany(UserModule.getCompanyId, parseInt(arr[0]));
              break;
            case 2:
              p = checkPermissionCompany(UserModule.getCompanyId, parseInt(arr[0]));
              break;
            case 3:
              p = checkPermissionRole(UserModule.getCompanyId, parseInt(arr[0]));
              break;
            case 4:
              p  = checkPermissionCompanyFromOrderType(UserModule.getCompanyId, parseInt(arr[0]), element.orderType);
              break;
          }
        }
      }
      if (element.vipLev) {
        p = p && element.vipLev === parseInt(UserModule.company.vip_level.substring(0, 1));
      }
      pList.push(p);
    }
  }
  let permission = pList.filter((val:any) => {
    return val;
  });
  return permission && permission.length > 0;
}
// export const ServerOrder : 1200,
